/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../../connect/v2/resources/error';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "solidshop": {
        "nested": {
          "v2": {
            "nested": {
              "service": {
                "nested": {
                  "HideInternalOrderRequest": {
                    "fields": {
                      "orderNumber": {
                        "type": "string",
                        "id": 1,
                        "rule": "required"
                      }
                    }
                  },
                  "HideInternalOrderResponse": {
                    "fields": {
                      "errors": {
                        "type": "squareup.connect.v2.resources.Error",
                        "id": 1,
                        "rule": "repeated"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * SOURCE HideInternalOrderRequest @ squareup/solidshop/v2/service/orders/hide_internal_order.proto at 11:1
 */
export const HideInternalOrderRequest = $root.lookupType('squareup.solidshop.v2.service.HideInternalOrderRequest');
fixType(HideInternalOrderRequest);
Builder.createAndAttachToType(HideInternalOrderRequest);
/**
 * SOURCE HideInternalOrderResponse @ squareup/solidshop/v2/service/orders/hide_internal_order.proto at 16:1
 */
export const HideInternalOrderResponse = $root.lookupType('squareup.solidshop.v2.service.HideInternalOrderResponse');
fixType(HideInternalOrderResponse);
Builder.createAndAttachToType(HideInternalOrderResponse);
